export const cguLocales = ["en", "fr", "es", "ge"]

export function getCguUrl(language) {
    return `${process.env["NX_PUBLIC_API_L2R"]}auth/terms/${language || "en"}/`
}
